import microuniversoApi from "app/api/microuniversoApi";
import store from "app/redux/store/store";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import { IProduto } from "app/types/produto/IProduto";
import * as R from 'ramda'
import { atualizarItensAction } from 'app/redux/orcamentoSlice'
import * as gridItensActions from 'app/redux/gridItensSlice'


import globalMU from "globalMU";
import { popularPropriedadesNovoItem } from "./popularPropriedadesNovoItem";

import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'
import { IOrcamento } from "app/types/IOrcamento";
import { preencherDadosTratamentoMadeira } from "./preencherDadosTratamentoMadeira";
import { EntitesProdutoAgregado } from "app/components/agregados/Agregados";
import { EntitesSimilares } from "app/components/similares/Similares";
import { ProdutosSugeridos } from "app/components/sugerir-produto-agregado/SugerirProdutoAgregado";
import { InputAdicionarCodigoServicoAgregado } from "app/types/ServicoAgregado";

export type AdicionarItensOutput = {
    status: "SUCESSO" | "ERRO"
}

declare var window: any

export async function AdicionarServicosAgregados(identificadorOrcamento: string, CodigosServicosAgregados: InputAdicionarCodigoServicoAgregado[]): Promise<AdicionarItensOutput> {

    try {
        globalMU.blockUI()

        const orcamentoLegado = window.orcamentoController.model

        const resposta = await microuniversoApi.Orcamento.adicionarServicosAgregados(
            identificadorOrcamento, 
            CodigosServicosAgregados);

         orcamentoLegado.atualizar(resposta, true, true)

        store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(resposta as IOrcamento))

        store.dispatch(gridItensActions.atualizarFlagAction())
        return {
            status: "Error" in resposta ? "ERRO" : "SUCESSO"
        }

    } finally {
        globalMU.unblockUI()
    }
}
